import React from 'react'
import { Col, Row } from 'react-bootstrap'
import '../styles/fontawesome/css/all.css'
import { Link } from 'react-router-dom'

const WhyAtumCharge = () => {
  return (
    
            <Row>
                <Col lg="4">
                    <div className="feature-panel-holder" data-hover="">
                        <div className="feature-panel">
                            <div className="feature-icon"><i className="fab fa-instalod"></i></div>
                            <div className="feature-content">
                                <h4>Easy to install</h4>
                                <p>Widely available in buildings, public spaces, Parking lots, commercial retail outlets & etc.,</p>
                            </div>
                            <Link to="/aboutus"><i className="fa fa-arrow-right"></i> <span>know More</span></Link>
                        </div>
                    </div>
                </Col>
                <Col lg="4">
                    <div className="feature-panel-holder" data-hover="">
                        <div className="feature-panel">
                            <div className="feature-icon"><i className="far fa-clock"></i></div>
                            <div className="feature-content">
                                <h4>EV users can save time</h4>
                                <p>Save time, and eliminate the distance they must travel to access public charging</p>
                            </div>
                            <Link to="/aboutus"><i className="fa fa-arrow-right"></i> <span>know More</span></Link>
                        </div>
                    </div>
                </Col>
                <Col lg="4">
                    <div className="feature-panel-holder" data-hover="">
                        <div className="feature-panel">
                            <div className="feature-icon"><i className="fas fa-rupee-sign"></i></div>
                            <div className="feature-content">
                                <h4>Less expensive</h4>
                                <p>Less expensive, Less space, reducing capital costs and requires less electricity</p>
                            </div>
                            <Link to="/aboutus"><i className="fa fa-arrow-right"></i> <span>know More</span></Link>
                        </div>
                    </div>
                </Col>
                <Col lg="4">
                    <div className="feature-panel-holder" data-hover="">
                        <div className="feature-panel">
                            <div className="feature-icon"><i className="fas fa-plug"></i></div>
                            <div className="feature-content">
                                <h4>Connected to low-voltage</h4>
                                <p>To single/three-phase power supply.</p>
                            </div>
                            <Link to="/aboutus"><i className="fa fa-arrow-right"></i> <span>know More</span></Link>
                        </div>
                    </div>
                </Col>
                <Col lg="4">
                    <div className="feature-panel-holder" data-hover="">
                        <div className="feature-panel">
                            <div className="feature-icon"><i className="far fa-save"></i></div>
                            <div className="feature-content">
                                <h4>Lower Driving cost</h4>
                                <p>Lower cost of driving community
                                </p>
                            </div>
                            <Link to="/aboutus"><i className="fa fa-arrow-right"></i> <span>know More</span></Link>
                        </div>
                    </div>
                </Col>
                <Col lg="4">
                    <div className="feature-panel-holder" data-hover="">
                        <div className="feature-panel">
                            <div className="feature-icon"><i className="fas fa-fan"></i></div>
                            <div className="feature-content">
                                <h4>Clean Air</h4>
                                <p>Clean Air commitment.
                                </p>
                            </div>
                            <Link to="/aboutus"><i className="fa fa-arrow-right"></i> <span>know More</span></Link>
                        </div>
                    </div>
                </Col>
            </Row>
       
  )
}

export default WhyAtumCharge